/* eslint-disable no-undef */
export default {
	name: "transaction-history",
	data() {
		return {
			transactionHistory: [],
			orderStatuses: [],
			currentBalance: null,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			transactionHistoryHeadings: [
				{
					text: "Transaction Date",
					field: "insertedOn"

				},
				// {
				// 	text: "Transaction Type",
				// 	field: "transactionType"
				// },
				{
					text: "Transaction Details",
					field: "comment"
				},
				{
					text: "Added/Deducted",
					field: "amountAsString"
				},
				{
					text: "Balance",
					field: "currentBalanceAsString"
				}
			],
			actionKeys:{
				viewOrder: "viewOrder"
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: 1,
				companyId: null,
				orderStatusId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			hasLoaded: false,
			loading: false
		};
	},
	methods: {
		getTransactionHistory(){
			this.loading = true;
			let request = {
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				searchQuery: this.filter.customerSearchQuery
			};
			customerCreditsService.getCompanyCreditHistoryByCompany(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.transactionHistory = successResponse.data.result;
						this.filterStateChanged = false;
						this.customerTransactionHistory = dataTableHelper.castFieldValues(this.transactionHistory);
						for(var i = 0; i < this.transactionHistory.length; i++){
							this.transactionHistory[i].amountAsString = currencyHelper.numberToCurrency(this.transactionHistory[i].amount);
							this.transactionHistory[i].currentBalanceAsString = currencyHelper.numberToCurrency(this.transactionHistory[i].currentBalance);
						}
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		getCurrentBalance(){
			customerCreditsService.getCurrentCompanyCreditByCompany(this.companyId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.result === null){
							this.currentBalance = currencyHelper.numberToCurrency(0);
						}
						else{
							this.currentBalance = currencyHelper.numberToCurrency(successResponse.data.result.currentBalance);
						}
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getTransactionHistory();
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
		}
	},
	mounted: function () {
		this.getTransactionHistory();
		this.getCurrentBalance();
		storeState.setPageTitleAction("Transaction History");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Transaction History");
	}
};